var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content grid grid__base" },
    [
      _c("cmp-header-panel", { staticClass: "page-content--header" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-content--content" },
        [
          _c(
            "transition",
            { attrs: { name: "trs-wave-loader-fade" } },
            [
              _vm.isLoading
                ? _c("cmp-wave-loader", { attrs: { facet: "content" } })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "transition",
            { attrs: { name: "trs-placeholder-content-fade" } },
            [
              !_vm.isLoading
                ? _c("cmp-main-placeholder", {
                    attrs: {
                      "page-title": _vm.pageTitle,
                      container: _vm.containers.main
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a0215b7a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0215b7a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./vehi-industriepfad/assets/src/js/app/framework/pages/content/index.vue
// module id = 449
// module chunks = 5